// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3LSF2","requiredAsterisk":"Info_requiredAsterisk__2NbE-"};